import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var AssetListItem = function AssetListItem() {
  return import('@/components/molecules/AssetListItem');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
export default {
  components: {
    PageHeader: PageHeader,
    AssetListItem: AssetListItem,
    RarityIcon: RarityIcon
  },
  data: function data() {
    return {
      myOwnExtensionType: [],
      myEthExtensionType: []
    };
  },
  computed: {
    myOwnExtensionIds: function myOwnExtensionIds() {
      return useExtensionStore().myOwnIds;
    },
    myOwnEthExtensionIds: function myOwnEthExtensionIds() {
      return useExtensionStore().myOwnEthIds;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    ethAddress: function ethAddress() {
      return useAuthStore().getEthAddress;
    },
    sortedExtensions: function sortedExtensions() {
      var extensions = useExtensionMaster().getExtensionTypes.map(function (e) {
        e.series = Number(e.extensionType.toString().slice(-3));
        return e;
      });
      extensions.sort(function (p, c) {
        if (p.series < c.series) return -1;
        if (p.series > c.series) return 1;
        return 0;
      });
      extensions.sort(function (p, c) {
        if ((p.rarity || 0) < (c.rarity || 0)) return 1;
        if ((p.rarity || 0) > (c.rarity || 0)) return -1;
        return 0;
      });
      return extensions;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return _this.fetchMyOwnExtensionIds();
          case 4:
            _context.next = 6;
            return _this.fetchExtensions(_this.myOwnExtensionIds);
          case 6:
            _this.myOwnExtensionIds.forEach(function (id) {
              _this.myOwnExtensionType.push(_this.getExtension(id).extensionType);
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchMyOwnExtensionIds: function fetchMyOwnExtensionIds() {
      return useExtensionStore().fetchMyOwnExtensionIds();
    },
    fetchEthExtensionIds: function fetchEthExtensionIds() {
      return useExtensionStore().fetchEthExtensionIds();
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    isOriginal: function isOriginal(extensionType) {
      return 1000 <= extensionType && extensionType < 11000;
    },
    isOwned: function isOwned(extensionType) {
      return this.myOwnExtensionType.includes(extensionType);
    },
    isOwnedInEth: function isOwnedInEth(extensionType) {
      if (this.isOwned(extensionType)) {
        return false;
      } else {
        return this.myEthExtensionType.includes(extensionType);
      }
    }
  }
};